/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.13",
    versionName: "0.2.0-nightly.2026.3.13",
    versionChannel: "nightly",
    buildDate: "2026-03-13T00:10:13.499Z",
    commitHash: "43ad0c213e401627c27c926347587e3e70d4069a",
};
